import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import strings from "../Globalization/index";
import EndoSetupInterfaceLogTable from '../AppGrid/EndoSetupInterfaceLogTable';
import { useBreadcrumbs } from '../contexts/Breadcrumbs';
import { usePrerequisites } from '../contexts/Prerequisites';

const InterfaceLogs = () => {
	const [, setBreadcrumbs] = useBreadcrumbs();
	const [{ strings }] = usePrerequisites();
	useEffect(() => {
		if (strings.InterfaceLogs && strings.interfaceLogs) {
			setBreadcrumbs({
				docTitle: strings.InterfaceLogs,
				breadcrumbs: [{ text: strings.interfaceLogs }]
			});
		}
	}, []);

	return (
		<Grid container>
			<Grid size={12}>
				<EndoSetupInterfaceLogTable />
			</Grid>
		</Grid>
	);
}

export default InterfaceLogs;